export const mazeData = {
  "(1, 1)": { E: 1, W: 0, N: 0, S: 1 },
  "(2, 1)": { E: 1, W: 0, N: 1, S: 0 },
  "(3, 1)": { E: 1, W: 0, N: 0, S: 0 },
  "(4, 1)": { E: 1, W: 0, N: 0, S: 1 },
  "(5, 1)": { E: 0, W: 0, N: 1, S: 1 },
  "(6, 1)": { E: 0, W: 0, N: 1, S: 1 },
  "(7, 1)": { E: 1, W: 0, N: 1, S: 1 },
  "(8, 1)": { E: 0, W: 0, N: 1, S: 1 },
  "(9, 1)": { E: 0, W: 0, N: 1, S: 1 },
  "(10, 1)": { E: 1, W: 0, N: 1, S: 0 },
  "(1, 2)": { E: 1, W: 1, N: 0, S: 0 },
  "(2, 2)": { E: 0, W: 1, N: 0, S: 1 },
  "(3, 2)": { E: 0, W: 1, N: 1, S: 0 },
  "(4, 2)": { E: 1, W: 1, N: 0, S: 1 },
  "(5, 2)": { E: 1, W: 0, N: 1, S: 1 },
  "(6, 2)": { E: 0, W: 0, N: 1, S: 1 },
  "(7, 2)": { E: 1, W: 1, N: 1, S: 0 },
  "(8, 2)": { E: 0, W: 0, N: 0, S: 1 },
  "(9, 2)": { E: 0, W: 0, N: 1, S: 1 },
  "(10, 2)": { E: 1, W: 1, N: 1, S: 0 },
  "(1, 3)": { E: 1, W: 1, N: 0, S: 0 },
  "(2, 3)": { E: 1, W: 0, N: 0, S: 1 },
  "(3, 3)": { E: 1, W: 0, N: 1, S: 0 },
  "(4, 3)": { E: 1, W: 1, N: 0, S: 0 },
  "(5, 3)": { E: 1, W: 1, N: 0, S: 0 },
  "(6, 3)": { E: 1, W: 0, N: 0, S: 1 },
  "(7, 3)": { E: 0, W: 1, N: 1, S: 0 },
  "(8, 3)": { E: 1, W: 0, N: 0, S: 1 },
  "(9, 3)": { E: 1, W: 0, N: 1, S: 1 },
  "(10, 3)": { E: 1, W: 1, N: 1, S: 0 },
  "(1, 4)": { E: 1, W: 1, N: 0, S: 1 },
  "(2, 4)": { E: 0, W: 1, N: 1, S: 0 },
  "(3, 4)": { E: 1, W: 1, N: 0, S: 0 },
  "(4, 4)": { E: 1, W: 1, N: 0, S: 0 },
  "(5, 4)": { E: 1, W: 1, N: 0, S: 0 },
  "(6, 4)": { E: 0, W: 1, N: 0, S: 1 },
  "(7, 4)": { E: 0, W: 0, N: 1, S: 0 },
  "(8, 4)": { E: 1, W: 1, N: 0, S: 0 },
  "(9, 4)": { E: 1, W: 1, N: 0, S: 0 },
  "(10, 4)": { E: 0, W: 1, N: 0, S: 0 },
  "(1, 5)": { E: 1, W: 1, N: 0, S: 0 },
  "(2, 5)": { E: 1, W: 0, N: 0, S: 1 },
  "(3, 5)": { E: 0, W: 1, N: 1, S: 0 },
  "(4, 5)": { E: 1, W: 1, N: 0, S: 0 },
  "(5, 5)": { E: 0, W: 1, N: 0, S: 1 },
  "(6, 5)": { E: 0, W: 0, N: 1, S: 1 },
  "(7, 5)": { E: 0, W: 0, N: 1, S: 1 },
  "(8, 5)": { E: 0, W: 1, N: 1, S: 0 },
  "(9, 5)": { E: 0, W: 1, N: 0, S: 1 },
  "(10, 5)": { E: 1, W: 0, N: 1, S: 0 },
  "(1, 6)": { E: 1, W: 1, N: 0, S: 1 },
  "(2, 6)": { E: 0, W: 1, N: 1, S: 1 },
  "(3, 6)": { E: 1, W: 0, N: 1, S: 0 },
  "(4, 6)": { E: 1, W: 1, N: 0, S: 0 },
  "(5, 6)": { E: 0, W: 0, N: 0, S: 1 },
  "(6, 6)": { E: 1, W: 0, N: 1, S: 1 },
  "(7, 6)": { E: 0, W: 0, N: 1, S: 1 },
  "(8, 6)": { E: 0, W: 0, N: 1, S: 0 },
  "(9, 6)": { E: 1, W: 0, N: 0, S: 1 },
  "(10, 6)": { E: 1, W: 1, N: 1, S: 0 },
  "(1, 7)": { E: 1, W: 1, N: 0, S: 0 },
  "(2, 7)": { E: 1, W: 0, N: 0, S: 0 },
  "(3, 7)": { E: 0, W: 1, N: 0, S: 1 },
  "(4, 7)": { E: 0, W: 1, N: 1, S: 1 },
  "(5, 7)": { E: 1, W: 0, N: 1, S: 1 },
  "(6, 7)": { E: 0, W: 1, N: 1, S: 0 },
  "(7, 7)": { E: 1, W: 0, N: 0, S: 1 },
  "(8, 7)": { E: 0, W: 0, N: 1, S: 1 },
  "(9, 7)": { E: 0, W: 1, N: 1, S: 0 },
  "(10, 7)": { E: 1, W: 1, N: 0, S: 0 },
  "(1, 8)": { E: 0, W: 1, N: 0, S: 1 },
  "(2, 8)": { E: 1, W: 1, N: 1, S: 0 },
  "(3, 8)": { E: 1, W: 0, N: 0, S: 0 },
  "(4, 8)": { E: 1, W: 0, N: 0, S: 1 },
  "(5, 8)": { E: 1, W: 1, N: 1, S: 1 },
  "(6, 8)": { E: 0, W: 0, N: 1, S: 1 },
  "(7, 8)": { E: 0, W: 1, N: 1, S: 1 },
  "(8, 8)": { E: 1, W: 0, N: 1, S: 1 },
  "(9, 8)": { E: 0, W: 0, N: 1, S: 1 },
  "(10, 8)": { E: 0, W: 1, N: 1, S: 0 },
  "(1, 9)": { E: 1, W: 0, N: 0, S: 0 },
  "(2, 9)": { E: 0, W: 1, N: 0, S: 1 },
  "(3, 9)": { E: 1, W: 1, N: 1, S: 0 },
  "(4, 9)": { E: 1, W: 1, N: 0, S: 0 },
  "(5, 9)": { E: 0, W: 1, N: 0, S: 0 },
  "(6, 9)": { E: 1, W: 0, N: 0, S: 1 },
  "(7, 9)": { E: 1, W: 0, N: 1, S: 1 },
  "(8, 9)": { E: 1, W: 1, N: 1, S: 0 },
  "(9, 9)": { E: 0, W: 0, N: 0, S: 1 },
  "(10, 9)": { E: 1, W: 0, N: 1, S: 0 },
  "(1, 10)": { E: 0, W: 1, N: 0, S: 1 },
  "(2, 10)": { E: 0, W: 0, N: 1, S: 1 },
  "(3, 10)": { E: 1, W: 1, N: 1, S: 0 },
  "(4, 10)": { E: 0, W: 1, N: 0, S: 1 },
  "(5, 10)": { E: 0, W: 0, N: 1, S: 1 },
  "(6, 10)": { E: 0, W: 1, N: 1, S: 0 },
  "(7, 10)": { E: 1, W: 1, N: 0, S: 0 },
  "(8, 10)": { E: 0, W: 1, N: 0, S: 1 },
  "(9, 10)": { E: 0, W: 0, N: 1, S: 1 },
  "(10, 10)": { E: 1, W: 1, N: 1, S: 0 },
  "(1, 11)": { E: 1, W: 0, N: 0, S: 1 },
  "(2, 11)": { E: 1, W: 0, N: 1, S: 1 },
  "(3, 11)": { E: 1, W: 1, N: 1, S: 1 },
  "(4, 11)": { E: 0, W: 0, N: 1, S: 1 },
  "(5, 11)": { E: 0, W: 0, N: 1, S: 1 },
  "(6, 11)": { E: 0, W: 0, N: 1, S: 1 },
  "(7, 11)": { E: 0, W: 1, N: 1, S: 1 },
  "(8, 11)": { E: 1, W: 0, N: 1, S: 0 },
  "(9, 11)": { E: 0, W: 0, N: 0, S: 1 },
  "(10, 11)": { E: 1, W: 1, N: 1, S: 0 },
  "(1, 12)": { E: 1, W: 1, N: 0, S: 0 },
  "(2, 12)": { E: 1, W: 1, N: 0, S: 0 },
  "(3, 12)": { E: 0, W: 1, N: 0, S: 0 },
  "(4, 12)": { E: 1, W: 0, N: 0, S: 1 },
  "(5, 12)": { E: 0, W: 0, N: 1, S: 1 },
  "(6, 12)": { E: 0, W: 0, N: 1, S: 1 },
  "(7, 12)": { E: 1, W: 0, N: 1, S: 0 },
  "(8, 12)": { E: 0, W: 1, N: 0, S: 1 },
  "(9, 12)": { E: 1, W: 0, N: 1, S: 0 },
  "(10, 12)": { E: 1, W: 1, N: 0, S: 0 },
  "(1, 13)": { E: 1, W: 1, N: 0, S: 0 },
  "(2, 13)": { E: 1, W: 1, N: 0, S: 1 },
  "(3, 13)": { E: 0, W: 0, N: 1, S: 1 },
  "(4, 13)": { E: 1, W: 1, N: 1, S: 0 },
  "(5, 13)": { E: 0, W: 0, N: 0, S: 1 },
  "(6, 13)": { E: 0, W: 0, N: 1, S: 1 },
  "(7, 13)": { E: 0, W: 1, N: 1, S: 1 },
  "(8, 13)": { E: 0, W: 0, N: 1, S: 1 },
  "(9, 13)": { E: 0, W: 1, N: 1, S: 0 },
  "(10, 13)": { E: 0, W: 1, N: 0, S: 0 },
  "(1, 14)": { E: 1, W: 1, N: 0, S: 1 },
  "(2, 14)": { E: 0, W: 1, N: 1, S: 1 },
  "(3, 14)": { E: 1, W: 0, N: 1, S: 1 },
  "(4, 14)": { E: 1, W: 1, N: 1, S: 0 },
  "(5, 14)": { E: 1, W: 0, N: 0, S: 1 },
  "(6, 14)": { E: 0, W: 0, N: 1, S: 1 },
  "(7, 14)": { E: 0, W: 0, N: 1, S: 1 },
  "(8, 14)": { E: 0, W: 0, N: 1, S: 1 },
  "(9, 14)": { E: 0, W: 0, N: 1, S: 1 },
  "(10, 14)": { E: 1, W: 0, N: 1, S: 0 },
  "(1, 15)": { E: 0, W: 1, N: 0, S: 1 },
  "(2, 15)": { E: 0, W: 0, N: 1, S: 1 },
  "(3, 15)": { E: 0, W: 1, N: 1, S: 0 },
  "(4, 15)": { E: 0, W: 1, N: 0, S: 1 },
  "(5, 15)": { E: 0, W: 1, N: 1, S: 1 },
  "(6, 15)": { E: 0, W: 0, N: 1, S: 1 },
  "(7, 15)": { E: 0, W: 0, N: 1, S: 1 },
  "(8, 15)": { E: 0, W: 0, N: 1, S: 1 },
  "(9, 15)": { E: 0, W: 0, N: 1, S: 1 },
  "(10, 15)": { E: 0, W: 1, N: 1, S: 0 },
};

// Nodes with heuristic values
export const nodesWithHeuristics = [
  "(1, 1)",
  "(2, 1)",
  "(3, 1)",
  "(4, 1)",
  "(7, 1)",
  "(10, 1)",
  "(2, 2)",
  "(3, 2)",
  "(4, 2)",
  "(5, 2)",
  "(7, 2)",
  "(8, 2)",
  "(10, 2)",
  "(2, 3)",
  "(3, 3)",
  "(6, 3)",
  "(7, 3)",
  "(8, 3)",
  "(9, 3)",
  "(10, 3)",
  "(1, 4)",
  "(2, 4)",
  "(6, 4)",
  "(7, 4)",
  "(10, 4)",
  "(2, 5)",
  "(3, 5)",
  "(5, 5)",
  "(8, 5)",
  "(9, 5)",
  "(10, 5)",
  "(1, 6)",
  "(2, 6)",
  "(3, 6)",
  "(5, 6)",
  "(6, 6)",
  "(8, 6)",
  "(9, 6)",
  "(10, 6)",
  "(2, 7)",
  "(3, 7)",
  "(4, 7)",
  "(5, 7)",
  "(6, 7)",
  "(7, 7)",
  "(9, 7)",
  "(1, 8)",
  "(2, 8)",
  "(3, 8)",
  "(4, 8)",
  "(5, 8)",
  "(7, 8)",
  "(8, 8)",
  "(10, 8)",
  "(1, 9)",
  "(2, 9)",
  "(3, 9)",
  "(5, 9)",
  "(6, 9)",
  "(7, 9)",
  "(8, 9)",
  "(9, 9)",
  "(10, 9)",
  "(1, 10)",
  "(3, 10)",
  "(4, 10)",
  "(6, 10)",
  "(8, 10)",
  "(10, 10)",
  "(1, 11)",
  "(2, 11)",
  "(3, 11)",
  "(6, 11)",
  "(7, 11)",
  "(8, 11)",
  "(9, 11)",
  "(10, 11)",
  "(3, 12)",
  "(4, 12)",
  "(7, 12)",
  "(8, 12)",
  "(9, 12)",
  "(2, 13)",
  "(4, 13)",
  "(5, 13)",
  "(7, 13)",
  "(9, 13)",
  "(10, 13)",
  "(1, 14)",
  "(2, 14)",
  "(3, 14)",
  "(4, 14)",
  "(5, 14)",
  "(10, 14)",
  "(1, 15)",
  "(3, 15)",
  "(4, 15)",
  "(5, 15)",
  "(10, 15)",
];

// Edges between nodes (undirected graph)
export const edges = [
  ["(1, 1)", "(1, 4)"],
  ["(1, 1)", "(2, 1)"],
  ["(2, 1)", "(2, 2)"],
  ["(2, 2)", "(3, 2)"],
  ["(3, 2)", "(3, 1)"],
  ["(1, 4)", "(2, 4)"],
  ["(2, 4)", "(2, 3)"],
  ["(2, 3)", "(3, 3)"],
  ["(3, 3)", "(3, 5)"],
  ["(3, 5)", "(2, 5)"],
  ["(2, 5)", "(2, 6)"],
  ["(2, 6)", "(1, 6)"],
  ["(1, 4)", "(1, 6)"],
  ["(1, 6)", "(1, 8)"],
  ["(1, 8)", "(2, 8)"],
  ["(2, 8)", "(2, 7)"],
  ["(2, 8)", "(2, 9)"],
  ["(2, 9)", "(3, 9)"],
  ["(3, 9)", "(3, 8)"],
  ["(3, 9)", "(3, 10)"],
  ["(3, 10)", "(1, 10)"],
  ["(1, 10)", "(1, 9)"],
  ["(3, 10)", "(3, 11)"],
  ["(3, 11)", "(2, 11)"],
  ["(2, 11)", "(1, 11)"],
  ["(1, 11)", "(1, 14)"],
  ["(2, 11)", "(2, 13)"],
  ["(2, 13)", "(2, 14)"],
  ["(2, 14)", "(1, 14)"],
  ["(3, 11)", "(3, 12)"],
  ["(2, 14)", "(3, 14)"],
  ["(1, 14)", "(1, 15)"],
  ["(1, 15)", "(3, 15)"],
  ["(3, 15)", "(3, 14)"],
  ["(3, 14)", "(4, 14)"],
  ["(4, 14)", "(4, 15)"],
  ["(4, 14)", "(4, 13)"],
  ["(2, 13)", "(4, 13)"],
  ["(4, 13)", "(4, 12)"],
  ["(4, 12)", "(7, 12)"],
  ["(2, 6)", "(3, 6)"],
  ["(3, 6)", "(3, 7)"],
  ["(3, 7)", "(4, 7)"],
  ["(4, 15)", "(5, 15)"],
  ["(4, 1)", "(7, 1)"],
  ["(4, 2)", "(5, 2)"],
  ["(4, 7)", "(5, 7)"],
  ["(4, 8)", "(5, 8)"],
  ["(4, 10)", "(6, 10)"],
  ["(4, 1)", "(4, 2)"],
  ["(4, 2)", "(4, 7)"],
  ["(4, 8)", "(4, 10)"],
  ["(5, 2)", "(5, 5)"],
  ["(5, 7)", "(5, 8)"],
  ["(5, 8)", "(5, 9)"],
  ["(5, 14)", "(5, 15)"],
  ["(5, 2)", "(7, 2)"],
  ["(5, 5)", "(8, 5)"],
  ["(5, 6)", "(6, 6)"],
  ["(5, 7)", "(6, 7)"],
  ["(5, 8)", "(7, 8)"],
  ["(5, 13)", "(7, 13)"],
  ["(5, 14)", "(10, 14)"],
  ["(5, 15)", "(10, 15)"],
  ["(6, 3)", "(7, 3)"],
  ["(6, 4)", "(7, 4)"],
  ["(6, 6)", "(8, 6)"],
  ["(6, 9)", "(7, 9)"],
  ["(6, 11)", "(7, 11)"],
  ["(7, 1)", "(10, 1)"],
  ["(7, 7)", "(9, 7)"],
  ["(7, 8)", "(8, 8)"],
  ["(7, 9)", "(8, 9)"],
  ["(7, 11)", "(8, 11)"],
  ["(7, 13)", "(9, 13)"],
  ["(8, 2)", "(10, 2)"],
  ["(8, 3)", "(9, 3)"],
  ["(8, 8)", "(10, 8)"],
  ["(8, 10)", "(10, 10)"],
  ["(8, 12)", "(9, 12)"],
  ["(9, 3)", "(10, 3)"],
  ["(9, 5)", "(10, 5)"],
  ["(9, 6)", "(10, 6)"],
  ["(9, 9)", "(10, 9)"],
  ["(9, 11)", "(10, 11)"],
  ["(6, 3)", "(6, 4)"],
  ["(6, 6)", "(6, 7)"],
  ["(6, 9)", "(6, 10)"],
  ["(7, 1)", "(7, 2)"],
  ["(7, 2)", "(7, 3)"],
  ["(7, 7)", "(7, 8)"],
  ["(7, 9)", "(7, 11)"],
  ["(7, 12)", "(7, 13)"],
  ["(3, 11)", "(6, 11)"],
  ["(8, 3)", "(8, 5)"],
  ["(8, 8)", "(8, 9)"],
  ["(8, 9)", "(8, 10)"],
  ["(8, 11)", "(8, 12)"],
  ["(9, 3)", "(9, 5)"],
  ["(9, 6)", "(9, 7)"],
  ["(9, 12)", "(9, 13)"],
  ["(10, 1)", "(10, 2)"],
  ["(10, 2)", "(10, 3)"],
  ["(10, 3)", "(10, 4)"],
  ["(10, 5)", "(10, 6)"],
  ["(10, 6)", "(10, 8)"],
  ["(10, 9)", "(10, 10)"],
  ["(10, 10)", "(10, 11)"],
  ["(10, 11)", "(10, 13)"],
  ["(10, 14)", "(10, 15)"],
];

// Weight of each edge (randomly generated for demonstration)
export const edgeWeights = {
  "(1, 1)-(1, 4)": 3,
  "(1, 1)-(2, 1)": 1,
  "(2, 1)-(2, 2)": 1,
  "(2, 2)-(3, 2)": 1,
  "(3, 2)-(3, 1)": 1,
  "(1, 4)-(2, 4)": 1,
  "(2, 4)-(2, 3)": 1,
  "(2, 3)-(3, 3)": 1,
  "(3, 3)-(3, 5)": 2,
  "(3, 5)-(2, 5)": 1,
  "(2, 5)-(2, 6)": 1,
  "(2, 6)-(1, 6)": 1,
  "(1, 4)-(1, 6)": 2,
  "(1, 6)-(1, 8)": 2,
  "(1, 8)-(2, 8)": 1,
  "(2, 8)-(2, 7)": 1,
  "(2, 8)-(2, 9)": 1,
  "(2, 9)-(3, 9)": 1,
  "(3, 9)-(3, 8)": 1,
  "(3, 9)-(3, 10)": 1,
  "(3, 10)-(1, 10)": 2,
  "(1, 10)-(1, 9)": 1,
  "(3, 10)-(3, 11)": 1,
  "(3, 11)-(2, 11)": 1,
  "(2, 11)-(1, 11)": 1,
  "(1, 11)-(1, 14)": 3,
  "(2, 11)-(2, 13)": 2,
  "(2, 13)-(2, 14)": 1,
  "(2, 14)-(1, 14)": 1,
  "(3, 11)-(3, 12)": 1,
  "(2, 14)-(3, 14)": 1,
  "(1, 14)-(1, 15)": 1,
  "(1, 15)-(3, 15)": 2,
  "(3, 15)-(3, 14)": 1,
  "(3, 14)-(4, 14)": 1,
  "(4, 14)-(4, 15)": 1,
  "(4, 14)-(4, 13)": 1,
  "(2, 13)-(4, 13)": 2,
  "(4, 13)-(4, 12)": 1,
  "(4, 12)-(7, 12)": 3,
  "(2, 6)-(3, 6)": 1,
  "(3, 6)-(3, 7)": 1,
  "(3, 7)-(4, 7)": 1,
  "(4, 15)-(5, 15)": 1,
  "(4, 1)-(7, 1)": 3,
  "(4, 2)-(5, 2)": 1,
  "(4, 7)-(5, 7)": 1,
  "(4, 8)-(5, 8)": 1,
  "(4, 10)-(6, 10)": 2,
  "(4, 1)-(4, 2)": 1,
  "(4, 2)-(4, 7)": 5,
  "(4, 8)-(4, 10)": 2,
  "(5, 2)-(5, 5)": 3,
  "(5, 7)-(5, 8)": 1,
  "(5, 8)-(5, 9)": 1,
  "(5, 14)-(5, 15)": 1,
  "(5, 2)-(7, 2)": 2,
  "(5, 5)-(8, 5)": 3,
  "(5, 6)-(6, 6)": 1,
  "(5, 7)-(6, 7)": 1,
  "(5, 8)-(7, 8)": 2,
  "(5, 13)-(7, 13)": 2,
  "(5, 14)-(10, 14)": 5,
  "(5, 15)-(10, 15)": 5,
  "(6, 3)-(7, 3)": 1,
  "(6, 4)-(7, 4)": 1,
  "(6, 6)-(8, 6)": 2,
  "(6, 9)-(7, 9)": 1,
  "(6, 11)-(7, 11)": 1,
  "(7, 1)-(10, 1)": 3,
  "(7, 7)-(9, 7)": 2,
  "(7, 8)-(8, 8)": 1,
  "(7, 9)-(8, 9)": 1,
  "(7, 11)-(8, 11)": 1,
  "(7, 13)-(9, 13)": 2,
  "(8, 2)-(10, 2)": 2,
  "(8, 3)-(9, 3)": 1,
  "(8, 8)-(10, 8)": 2,
  "(8, 10)-(10, 10)": 2,
  "(8, 12)-(9, 12)": 1,
  "(9, 3)-(10, 3)": 1,
  "(9, 5)-(10, 5)": 1,
  "(9, 6)-(10, 6)": 1,
  "(9, 9)-(10, 9)": 1,
  "(9, 11)-(10, 11)": 1,
  "(6, 3)-(6, 4)": 1,
  "(6, 6)-(6, 7)": 1,
  "(6, 9)-(6, 10)": 1,
  "(7, 1)-(7, 2)": 1,
  "(7, 2)-(7, 3)": 1,
  "(7, 7)-(7, 8)": 1,
  "(7, 9)-(7, 11)": 2,
  "(7, 12)-(7, 13)": 1,
  "(3, 11)-(6, 11)": 3,
  "(8, 3)-(8, 5)": 2,
  "(8, 8)-(8, 9)": 1,
  "(8, 9)-(8, 10)": 1,
  "(8, 11)-(8, 12)": 1,
  "(9, 3)-(9, 5)": 2,
  "(9, 6)-(9, 7)": 1,
  "(9, 12)-(9, 13)": 1,
  "(10, 1)-(10, 2)": 1,
  "(10, 2)-(10, 3)": 1,
  "(10, 3)-(10, 4)": 1,
  "(10, 5)-(10, 6)": 1,
  "(10, 6)-(10, 8)": 2,
  "(10, 9)-(10, 10)": 1,
  "(10, 10)-(10, 11)": 1,
  "(10, 11)-(10, 13)": 2,
  "(10, 14)-(10, 15)": 1,
};
